import { Checkbox } from "@mui/material";
import { memo } from "react";

const BrandCheckbox = memo(({ label, checked, onChange }) => {
  return (
    <div className="flex items-center justify-start flex-row">
      <Checkbox
        sx={{
          color: "#5652B0",
          "&.Mui-checked": {
            color: "#5652B0",
          },
        }}
        checked={checked}
        onChange={onChange}
      />
      <p className="font-outfit text-[18px] font-medium">{label}</p>
    </div>
  );
});

export default BrandCheckbox;
